import { render, staticRenderFns } from "./SalesForceTab.vue?vue&type=template&id=fdb01a30&scoped=true&"
import script from "./SalesForceTab.vue?vue&type=script&lang=js&"
export * from "./SalesForceTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesForceTab.vue?vue&type=style&index=0&id=fdb01a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb01a30",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput})
